import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user', 'userIsCompany']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o honorário:<br><strong>${this.currentEntity.address.name} - vigência ${this.currentEntity.validity}</strong>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/index/resources/computed.js